module.exports = {
	"core": {
		"dbcache": 100,
		"maxorphantx": 10,
		"maxmempool": 50
	},
	"network": {
		"maxconnections": 40,
		"maxuploadtarget": 5000
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/pi.json
 ** module id = 44
 ** module chunks = 0
 **/